import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('email_to_the_supplier'),
    fieldTo: defineMessage('to_1'),
    fieldFrom: defineMessage('from_1'),
    fieldSubject: defineMessage('subject'),
    fieldCc: defineMessage('cc_1'),
    fieldReplyTo: defineMessage('reply_to'),
    fieldBody: defineMessage('body'),
    attachmentsTitle: defineMessage('attachments_for_the_supplier'),
};
